import api from './api';

export interface UserActivity {
  id: number;
  user_id: number;
  user_name?: string;
  action: string;
  entity_type?: string;
  entity_id?: number;
  details?: string;
  ip_address?: string;
  created_at: string;
}

export interface ActivityFilters {
  user_id?: number;
  action?: string;
  entity_type?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
}

export interface ActivityStats {
  total_activities: number;
  unique_users: number;
  logins: number;
  logouts: number;
  updates: number;
  deletes: number;
  page_visits: number;
}

export interface ActivityResponse {
  data: UserActivity[];
  stats: ActivityStats;
  pagination: {
    limit: number;
    offset: number;
    total: number;
  };
}

export const activityService = {
  getAll: async (filters?: ActivityFilters): Promise<ActivityResponse> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, String(value));
        }
      });
    }
    const response = await api.get(`/api/activities?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<UserActivity> => {
    const response = await api.get(`/api/activities/${id}`);
    return response.data.data;
  },

  logPageVisit: async (page: string, details?: string): Promise<void> => {
    await api.post('/api/activities/page-visit', { page, details });
  },

  cleanup: async (days: number = 15): Promise<{ deleted_count: number }> => {
    const response = await api.post('/api/activities/cleanup', { days });
    return response.data;
  }
};




